/** Window events for COA draft autosave indicator in Header (same UX as Critique autosave). */
export const COA_DRAFT_SAVE_EVENTS = {
  STARTED: "coa-draft-save-started",
  COMPLETED: "coa-draft-save-completed",
  SUCCESS: "coa-draft-save-success",
  FAILED: "coa-draft-save-failed",
  CLEAR: "coa-draft-save-clear",
};
